import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Auth0App from './Auth0App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import { 
  AUTH0_DOMAIN, 
  AUTH0_CLIENT_ID, 
  AUTH0_AUDIENCE,
  AUTH0_REDIRECT_URI,
  USE_AUTH0,
  DEPLOYMENT_REGION
} from './utils/constants';
import { performFullCacheCleanup } from './utils/cacheCleanup';

const root = ReactDOM.createRoot(document.getElementById('root'));

const renderAuth0App = () => {
  // Handle redirect after Auth0 login to restore intended destination
  const onRedirectCallback = (appState) => {
    // eslint-disable-next-line no-restricted-globals
    window.history.replaceState(
      {},
      document.title,
      // eslint-disable-next-line no-restricted-globals
      appState?.returnTo || window.location.pathname
    );
  };

  // Auth0 authentication
  root.render(
    <React.StrictMode>
      <Auth0Provider
        domain={AUTH0_DOMAIN}
        clientId={AUTH0_CLIENT_ID}
        authorizationParams={{
          redirect_uri: AUTH0_REDIRECT_URI,
          audience: AUTH0_AUDIENCE
        }}
        cacheLocation="localstorage"
        onRedirectCallback={onRedirectCallback}
      >
        <BrowserRouter>
          <Auth0App />
        </BrowserRouter>
      </Auth0Provider>
    </React.StrictMode>
  );
};

const bootstrapApp = () => {
  if (USE_AUTH0) {
    // eslint-disable-next-line no-restricted-globals
    const urlParams = new URLSearchParams(window.location.search);
    const isAuth0Callback = urlParams.has('code') && urlParams.has('state');
    
    // Check if this is an internal app route (not the landing page)
    // eslint-disable-next-line no-restricted-globals
    const pathname = window.location.pathname;
    const isInternalRoute = pathname.includes('/asset-dashboard') || 
                           pathname.includes('/asset-browser') ||
                           pathname.includes('/file-browsing') ||
                           pathname.includes('/file-to-machine') ||
                           pathname.includes('/uploaded-files') ||
                           pathname.includes('/user-management') ||
                           pathname.includes('/global-audit-logs') ||
                           pathname.includes('/device-audit-logs') ||
                           pathname.includes('/registration') ||
                           pathname.includes('/data-items') ||
                           pathname.includes('/scm');
    
    if (!isAuth0Callback && !isInternalRoute) {
      // Only cleanup on landing page visits (root URL)
      console.log("🚀 Bootstrapping Auth0 app with full cleanup...");
      performFullCacheCleanup();
    } else if (isAuth0Callback) {
      console.log("⏭️ Skipping cleanup - Auth0 callback detected");
    } else {
      console.log("⏭️ Skipping cleanup - Internal route detected:", pathname);
    }
    
    renderAuth0App();
    return;
  }

  if (DEPLOYMENT_REGION === "USA") {
    // Cognito authentication (USA)
    // Dynamic import to avoid initializing unused auth providers
    import('./CognitoApp').then((module) => {
      const CApp = module.default;
      root.render(
        <React.StrictMode>
          <BrowserRouter>
            <CApp />
          </BrowserRouter>
        </React.StrictMode>
      );
    });
    return;
  }

  // Keycloak authentication (China)
  // Dynamic import to avoid initializing unused auth providers
  import('./KeycloakApp').then((module) => {
    const KApp = module.default;
    root.render(
      <React.StrictMode>
        <BrowserRouter>
          <KApp />
        </BrowserRouter>
      </React.StrictMode>
    );
  });
};

bootstrapApp();

reportWebVitals();
